import AirplaneLoader from "./AirplaneLoader";

export default AirplaneLoader;
